import { Stack, Group, Text, Badge, Button } from "@mantine/core";
import { IconEdit } from "@tabler/icons-react";
import { AllowedBillingScenario } from "../../../services/prefixService";

interface PrefixAllowedBillingScenariosPanelProps {
  allowedBillingScenarios: AllowedBillingScenario[];
  onEdit: () => void;
}

export default function PrefixAllowedBillingScenariosPanel({
  allowedBillingScenarios,
  onEdit,
}: PrefixAllowedBillingScenariosPanelProps) {
  return (
    <Stack gap="md">
      <Group justify="space-between">
        <Text fw={500}>Allowed Billing Scenarios</Text>
        <Button
          variant="light"
          size="xs"
          leftSection={<IconEdit size={14} />}
          onClick={onEdit}
        >
          Edit
        </Button>
      </Group>

      {allowedBillingScenarios.length === 0 ? (
        <Text c="dimmed" size="sm">
          No billing scenarios configured. Click Edit to add allowed billing
          scenarios.
        </Text>
      ) : (
        <Stack gap="xs">
          {allowedBillingScenarios.map((abs) => (
            <Group key={abs.id} gap="sm">
              <Text size="sm">
                {abs.billingScenario?.name ?? abs.billingScenarioId}
              </Text>
              {abs.isDefault && (
                <Badge color="blue" variant="light" size="xs">
                  Default
                </Badge>
              )}
            </Group>
          ))}
        </Stack>
      )}
    </Stack>
  );
}
